import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { FieldDef, FormsProps, FormsResultsDTO } from '../../types/forms';
import { getFormsRows } from '../../api/forms.api';
import Loading from '../loading/Loading';
import FormsResultsTable from '../FormsResultsTable/FormsResultsTable';
import { transformFormResponses } from '../../utils/forms.utils';
import { useEvents } from '../../hooks/useEvents';
import { useError } from '../../context/error-context';

const ViewUserTable = ({ formId, formAllFields, linkedFormId, skin, formName }: FormsProps) => {
    const [ results, setResults ] = useState<FormsResultsDTO['responses']>([]);
    const [ resultsLoading, setResultsLoading ] = useState(true);
    const { subscribe } = useEvents();
    const { showError } = useError();

    let realFormId = +formId;

    if (linkedFormId) {
        realFormId = linkedFormId;
    }

    const fetchRows = () => {
        setResultsLoading(true);

        getFormsRows(realFormId, formId)
        .then(response => {
            setResults(response.responses);
        })
        .catch((err) => {
            showError({
                code: err.response?.status || 500,
                message: 'API Error',
                description: 'Failed to fetch data',
                showRefresh: true,
            });
        })
        .finally(() => setResultsLoading(false));
    };

    useEffect(() => {
        fetchRows();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ realFormId, formId ]);

    useEffect(() => {
        return subscribe(`REFRESH_FORMS_${realFormId}`, () => {
            fetchRows();
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ realFormId, formId, subscribe ]);

    const shouldShowColumn = (field: FieldDef): boolean => {
        if (skin === 'skin3' && field.type === 'string') {
            return false;
        }

        return !field.hidden;
    };

    const finalFormName = formName || 'Submitted Results';

    return (
        <div>
            {resultsLoading ? <Loading/> : (
                <div style={{ margin: '16px', width: '98%' }}>
                    <div>
                        <Typography
                            variant="h4"
                            gutterBottom
                            sx={skin === 'skin5' ? {
                                color: '#22312d',
                                fontFamily: "Georgia, 'Times New Roman', serif",
                                fontWeight: 700,
                            } : undefined}
                        >
                            {finalFormName}
                        </Typography>
                    </div>

                    {formAllFields.length > 0 ? (
                        <FormsResultsTable
                            config={{ fields: formAllFields.filter(shouldShowColumn) }}
                            formName={finalFormName}
                            data={transformFormResponses(results)}
                            isUserFriendlyTable
                            isSearchable
                            isSortable
                            skin={skin}
                        />
                    ) : (
                        <Typography variant="h6">
                            Couldn't load the results.
                        </Typography>
                    )}
                </div>
            )}
        </div>
    );
};

export default ViewUserTable;